<template>
  <div class="d-flex flex-column flex-root min-vh-100">
    <div
      class="login login-1 d-flex flex-column flex-lg-row flex-row-fluid bg-white"
      :class="{
        'login-signin-on': this.state == 'signin',
        'login-signup-on': this.state == 'signup',
        'login-forgot-on': this.state == 'forgot',
      }"
      id="kt_login"
    >
      <!--begin::Content-->
      <div
        class="login-content flex-row-fluid d-flex flex-column justify-content-center position-relative overflow-hidden p-7 mx-auto"
      >
        <div class="d-flex flex-column-fluid flex-center">
          <!--begin::Signin-->
          <div class="login-form login-signin">
            <validation-observer ref="loginForm" #default="{ invalid }">
              <b-form class="auth-login-form mt-2">


                <!--begin::Heading-->
								<div class="text-center mb-15">
									<!--begin::Title-->
									<h1 class="text-dark fw-bolder mb-3 font-weight-bolder h1">Sign In</h1>
									<!--end::Title-->
									<!--begin::Subtitle-->
									<div class="text-gray-500 fw-semibold h6">Welcome to Eye Clinic</div>
									<!--end::Subtitle=-->
								</div>

                <!-- <div class="pb-13 pt-lg-0 pt-5">
                  <h3
                    class="font-weight-bolder text-dark text-center font-size-h4 font-size-h1-lg"
                  >
                    Welcome to Eye clinic
                  </h3>
                </div> -->
                <b-form-group
                  label-for="login-email"
                  label-class="font-size-h6 font-weight-bolder text-dark"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Email"
                    vid="email"
                    rules="required|email"
                  >
                    <b-form-input
                      id="login-email"
                      v-model="form.userEmail"
                      name="login-email"
                      :state="errors.length > 0 ? false : null"
                      class="p-6"
                      placeholder="Email"
                      @keyup.enter="login"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group
                  label-for="login-password"
                  label-class="font-size-h6 font-weight-bolder text-dark"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Password"
                    vid="password"
                    rules="required"
                  >
                    <b-input-group
                      class="input-group-merge"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                    >
                      <b-form-input
                        id="login-password"
                        v-model="form.password"
                        name="login-password"
                        class="p-6"
                        :type="passwordFieldType"
                        autocomplete="off"
                        placeholder="Password"
                        @keyup.enter="login"
                      />
                      <b-input-group-append is-text class="cursor-pointer">
                        <i
                          :class="passwordToggleIcon"
                          @click="togglePasswordVisibility"
                        ></i>
                      </b-input-group-append>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-overlay
                  :show="loading"
                  opacity="1"
                  spinner-variant="white"
                  variant="primary"
                >
                  <b-button
                    variant="primary"
                    class="font-size-h6 font-weight-bolder py-3"
                    block
                    :disabled="invalid"
                    @click="login"
                  >
                    Sign in
                  </b-button>
                </b-overlay>
              </b-form>
            </validation-observer>
          </div>
          <!--end::Signin-->
        </div>

        <!--begin::Content footer-->
        <div
          class="d-flex justify-content-center text-dark py-7 py-lg-0"
        >
          <span>Copyright © {{ getYear }} - Eye Clinic</span>
        </div>
        <!--end::Content footer-->




        <!--begin::Content footer-->
        <!-- <div
          class="d-flex justify-content-lg-start justify-content-center align-items-end py-7 py-lg-0"
        >
          <a href="#" class="text-primary font-weight-bolder font-size-h5"
            >Terms</a
          >
          <a href="#" class="text-primary ml-10 font-weight-bolder font-size-h5"
            >Plans</a
          >
          <a href="#" class="text-primary ml-10 font-weight-bolder font-size-h5"
            >Contact Us</a
          >
        </div> -->
        <!--end::Content footer-->
      </div>
      <!--end::Content-->

      <!--begin::Aside-->
      <div
        class="login-aside d-flex flex-column justify-content-center flex-row-auto"
      >
        <div class="d-flex flex-column-auto flex-column">
          <img
              :src="appLogoImage"
              alt="logo Eye Clinic"
              class="login-logo"
            />
        </div>
      </div>
      <!--begin::Aside-->

    </div>
    <b-modal
      centered
      size="lg"
      v-model="conditionFacility"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <b-form-group label="Choose a clinic" label-for="clinic">
        <treeselect
          v-model="facility"
          :options="optionsFacilities"
          :clearable="true"
          :normalizer="normalizer"
        >
        </treeselect>
      </b-form-group>
    </b-modal>
    <ToastNotification ref="toast" />
  </div>
</template>

<!-- Load login custom page styles -->
<style lang="scss">
@import "@/assets/sass/pages/login/login-1.scss";
</style>

<script>
import {
  BForm,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BOverlay,
  BButton,
} from "bootstrap-vue";
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";

import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email } from "@/core/utils/validations/validations.js";

import ToastNotification from "@/components/ToastNotification";

import axiosU from "@/core/services/api/auth";
import axiosF from "@/core/services/api/admin/facilities";
import performanceAlertService from "@/core/services/performanceAlert.service";

export default {
  name: "login-1",
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BOverlay,
    BButton,

    ToastNotification,

    ValidationProvider,
    ValidationObserver,
  },
  watch: {
    facility(newVal) {
      if (newVal && !this.onlyFacility) {
        this.changeRoute();
      }
    },
  },
  data() {
    return {
      state: "signin",
      // Remove this dummy login info
      form: {
        userEmail: "",
        password: "",
      },
      user: null,
      token: null,
      permissions: null,
      conditionFacility: false,
      facility: null,
      optionsFacilities: [],
      onlyFacility: false,
      isInsuranceAgent: false,
      isAdminAgent: false,
      sideImg: "",

      required,
      email,

      passwordFieldType: "password",
      loading: false,
      normalizer(node) {
        return {
          id: node.id,
          label: node.name,
        };
      },
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password"
        ? "fas fa-eye"
        : "fas fa-eye-slash";
    },
    appLogoImage() {
      return (
        process.env.BASE_URL + "media/logos/Recurso 6.png"
      );
    },
    getYear() {
      return new Date().getFullYear();
    },
  },
  methods: {
    togglePasswordVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
    },
    login() {
      this.loading = true;
      const { userEmail, password } = this.form;
      const decodedUser = {
        email: userEmail,
        password: btoa(password),
      };
      axiosU
        .loginUser(decodedUser)
        .then(({ user, type, permissions, token }) => {
          if (user != null) {
            this.user = user;
            this.token = token;
            this.permissions = permissions || [];
            this.isInsuranceAgent =
              Array.isArray(user.roles) &&
              user.roles.some((role) => Number(role.id) === 7);
            this.isAdminAgent =
              Array.isArray(user.roles) &&
              user.roles.some((role) => Number(role.id) === 8);
            const isMember = Array.isArray(user.roles) &&
              user.roles.some((role) => Number(role.id) === 10);
            const isAgentPlan = Array.isArray(user.roles) &&
              user.roles.some((role) => Number(role.id) === 9);

            if (!this.isInsuranceAgent && !this.isAdminAgent && !isMember && !isAgentPlan) {
              this.optionsFacilities = user.facilities || [];
              // Verificar si el usuario es superadmin
              const isSuperAdmin = Array.isArray(user.roles) &&
                user.roles.some((role) => role.id === 1 || role.name === "superadmin");
              
              if (this.optionsFacilities.length === 1) {
                this.onlyFacility = true;
                this.changeRoute(this.optionsFacilities[0].id);
                this.facility = this.optionsFacilities[0];
              } else if (isSuperAdmin && this.optionsFacilities.length > 0) {
                // Superadmin: seleccionar automáticamente el primer facility sin mostrar el select
                this.conditionFacility = false;
                this.onlyFacility = false;
                this.facility = this.optionsFacilities[0];
                localStorage.setItem(
                  "setFacilityOptions",
                  btoa(JSON.stringify(this.optionsFacilities))
                );
                this.changeRoute(this.optionsFacilities[0].id, this.optionsFacilities[0]);
              } else {
                this.conditionFacility = true;
              }
              localStorage.setItem(
                "setFacilityOptions",
                btoa(JSON.stringify(this.optionsFacilities))
              );
            } else if (isAgentPlan) {
              // Agent Plan: usar SOLO las facilities que vienen en user.facilities del login
              this.optionsFacilities = user.facilities || [];
              this.conditionFacility = false; // No mostrar el select
              
              // Si hay facilities en el user, usarlas directamente
              if (this.optionsFacilities && this.optionsFacilities.length > 0) {
                // Guardar las opciones de facilities en localStorage
                localStorage.setItem(
                  "setFacilityOptions",
                  btoa(JSON.stringify(this.optionsFacilities))
                );
                // Seleccionar automáticamente la primera facility autorizada
                this.facility = this.optionsFacilities[0];
                this.onlyFacility = false;
                // Guardar en una variable local para asegurar que esté disponible en changeRoute
                const selectedFacility = this.optionsFacilities[0];
                const facilityId = selectedFacility.id;
                // Llamar changeRoute con el ID y pasar la facility como referencia
                this.changeRoute(facilityId, selectedFacility);
              } else {
                // Si no hay facilities en el user, redirigir sin facility
                this.optionsFacilities = [];
                this.changeRoute();
              }
            } else {
              // Insurance Agent, Admin Agent o Member: usar user.facilities si vienen del backend
              this.optionsFacilities = user.facilities || [];
              this.conditionFacility = false;
              if (this.optionsFacilities.length > 0) {
                localStorage.setItem(
                  "setFacilityOptions",
                  btoa(JSON.stringify(this.optionsFacilities))
                );
                this.facility = this.optionsFacilities[0];
                const selectedFacility = this.optionsFacilities[0];
                this.changeRoute(selectedFacility.id, selectedFacility);
              } else {
                this.changeRoute();
              }
            }
          }
          this.loading = false;
        }).catch(() =>{
          this.loading = false;
          this.$refs.toast.danger("User type not added");
        })
    },
    changeRoute(id, facilityObj = null) {
      const user = this.user;
      const token = this.token;
      const isInsuranceAgent = this.isInsuranceAgent;
      const isAdminAgent = this.isAdminAgent;
      const permisosTotal = Array.isArray(this.permissions)
        ? this.permissions
            .filter((item) => typeof item === "string")
            .map((item) => ({
              action: item.split(".")[1],
              subject: item.split(".")[0],
            }))
        : [];
      let abilityPayload = [];

      if (user.roles[0].id === 1) {
        abilityPayload = [
          {
            action: "manage",
            subject: "all",
          },
        ];
      } else if (isInsuranceAgent) {
        abilityPayload = [
          {
            action: "read",
            subject: "insuranceAgentDashboard",
          },
        ];
      } else if (isAdminAgent) {
        abilityPayload = [
          {
            action: "read",
            subject: "adminAgentDashboard",
          },
        ];
      } else {
        abilityPayload = permisosTotal;
      }

      if (
        !abilityPayload.some(
          (permission) => permission.subject === "Auth"
        )
      ) {
        abilityPayload.push({
          action: "read",
          subject: "Auth",
        });
      }

      localStorage.setItem(
        "userData",
        JSON.stringify({
          ...user,
          role: user.roles[0].name,
          ability: abilityPayload,
        })
      );
      localStorage.setItem("accessToken", token);
      const userData = JSON.parse(localStorage.getItem("userData"));
      this.$ability.update(userData.ability);
      performanceAlertService.refreshPendingAlert({ force: true });

      if (isInsuranceAgent) {
        if (id && facilityObj) {
          const facilityToSave = facilityObj;
          localStorage.setItem("facility", id.toString());
          localStorage.setItem("Facility", btoa(JSON.stringify(facilityToSave)));
          axiosU.selectFacility({ facilities_id: id }).then((res) => {
            const facilityId = res?.facilities_id || res?.data?.facilities_id || id;
            localStorage.setItem("facility", facilityId.toString());
            localStorage.setItem("Facility", btoa(JSON.stringify(facilityToSave)));
            this.$router.replace({ name: "insurance-agent-dashboard" }).catch(() => {});
          }).catch(() => {
            this.$router.replace({ name: "insurance-agent-dashboard" }).catch(() => {});
          });
        } else {
          localStorage.removeItem("facility");
          localStorage.removeItem("Facility");
          localStorage.removeItem("setFacilityOptions");
          this.$router.replace({ name: "insurance-agent-dashboard" }).catch(() => {});
        }
        return;
      }

      // Check for Member (role 10) or Agent Plan (role 9)
      const isMember = user.roles[0].id === 10;
      const isAgentPlan = user.roles[0].id === 9;

      if (isAdminAgent) {
        if (id && facilityObj) {
          const facilityToSave = facilityObj;
          localStorage.setItem("facility", id.toString());
          localStorage.setItem("Facility", btoa(JSON.stringify(facilityToSave)));
          axiosU.selectFacility({ facilities_id: id }).then((res) => {
            const facilityId = res?.facilities_id || res?.data?.facilities_id || id;
            localStorage.setItem("facility", facilityId.toString());
            localStorage.setItem("Facility", btoa(JSON.stringify(facilityToSave)));
            this.$router.replace({ name: "admin-agent-dashboard" }).catch(() => {});
          }).catch(() => {
            this.$router.replace({ name: "admin-agent-dashboard" }).catch(() => {});
          });
        } else {
          localStorage.removeItem("facility");
          localStorage.removeItem("Facility");
          localStorage.removeItem("setFacilityOptions");
          this.$router.replace({ name: "admin-agent-dashboard" }).catch(() => {});
        }
        return;
      }

      if (isMember) {
        if (id && facilityObj) {
          const facilityToSave = facilityObj;
          localStorage.setItem("facility", id.toString());
          localStorage.setItem("Facility", btoa(JSON.stringify(facilityToSave)));
          axiosU.selectFacility({ facilities_id: id }).then((res) => {
            const facilityId = res?.facilities_id || res?.data?.facilities_id || id;
            localStorage.setItem("facility", facilityId.toString());
            localStorage.setItem("Facility", btoa(JSON.stringify(facilityToSave)));
            this.$router.replace({ name: "member-dashboard" }).catch(() => {});
          }).catch(() => {
            this.$router.replace({ name: "member-dashboard" }).catch(() => {});
          });
        } else {
          localStorage.removeItem("facility");
          localStorage.removeItem("Facility");
          localStorage.removeItem("setFacilityOptions");
          this.$router.replace({ name: "member-dashboard" }).catch(() => {});
        }
        return;
      }

      if (isAgentPlan) {
        // Agent Plan: usar SOLO las facilities que vienen en user.facilities del login
        // Si hay ID y facilityObj, significa que hay una facility del user.facilities
        if (id && facilityObj) {
          // Usar el objeto facility pasado como parámetro (viene directamente del login)
          const facilityToSave = facilityObj;
          
          const datos = {
            facilities_id: id,
          };
          
          // Guardar en localStorage ANTES de llamar selectFacility
          localStorage.setItem("facility", id.toString());
          localStorage.setItem("Facility", btoa(JSON.stringify(facilityToSave)));
          
          // Llamar selectFacility para validar en el backend
          axiosU.selectFacility(datos).then((res) => {
            const facilityId = res?.facilities_id || res?.data?.facilities_id || id;
            localStorage.setItem("facility", facilityId.toString());
            // Asegurar que Facility esté guardado
            localStorage.setItem("Facility", btoa(JSON.stringify(facilityToSave)));
            this.$router
              .replace({ name: "agent-plan-dashboard" })
              .catch(() => {});
          }).catch((error) => {
            console.error('Error selecting facility for Agent Plan:', error);
            // Los valores ya están guardados en localStorage, redirigir
            this.$router
              .replace({ name: "agent-plan-dashboard" })
              .catch(() => {});
          });
        } else {
          // Si no hay ID ni facilityObj, redirigir sin facility (no hacer llamadas al API)
          // Las facilities para agent plan SOLO vienen en user.facilities del login
          this.$router
            .replace({ name: "agent-plan-dashboard" })
            .catch(() => {});
        }
        return;
      }

      let datos;
      if (id) {
        datos = {
          facilities_id: id,
        };
      } else {
        // this.facility puede ser un objeto o un ID
        const facilityId = typeof this.facility === 'object' ? this.facility?.id : this.facility;
        datos = {
          facilities_id: facilityId,
        };
      }
      axiosU.selectFacility(datos).then((res) => {
        // Usar res.facilities_id si está disponible, sino usar el ID directamente
        const facilityId = res?.facilities_id || res?.data?.facilities_id || (id || (typeof this.facility === 'object' ? this.facility?.id : this.facility));
        localStorage.setItem("facility", facilityId.toString());
        // Asegurar que se guarde el objeto facility correcto
        // Prioridad: facilityObj (parámetro) > this.facility (si es objeto) > buscar en optionsFacilities
        let facilityToSave = facilityObj;
        if (!facilityToSave && typeof this.facility === 'object') {
          facilityToSave = this.facility;
        } else if (!facilityToSave && this.optionsFacilities && this.optionsFacilities.length > 0) {
          facilityToSave = this.optionsFacilities.find(f => f.id === facilityId) || this.optionsFacilities[0];
        }
        if (facilityToSave) {
          localStorage.setItem("Facility", btoa(JSON.stringify(facilityToSave)));
        }
        console.log(userData.roles[0].name);
        this.$router
          .replace({ name: "dashboard-all" })
          .catch(() => {});
      });
    },
  },
};
</script>
